<script>
import UserLabel from '@/js/components/user/UserLabel';

export default {
    name: 'ContactLabel',

    functional: true,

    props: {
        user: {type: Object, default: null},
        hideIcon: {type: Boolean},
        showLink: {type: Boolean},
        isSecondary: {type: Boolean},
        none: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            user: props.user,
            prefersNickname: true,
            hideIcon: props.hideIcon,
            showLink: props.showLink,
            iconClass: 'fa-fw fa-star ' + (props.isSecondary ? 'fa' : 'far'),
            none: props.none || parent.$t('common.labels.contact.nil'),
        };

        data.attrs = {
            ...data.attrs,
            title: props.isSecondary
                ? parent.$t('common.labels.contact.secondary')
                : parent.$t('common.labels.contact.primary'),
        };

        data.directives = [{name: 'tooltip'}].concat(data.directives || []);

        return createElement(UserLabel, data);
    },
};
</script>
